import {ContentRow, ContentCol, StyledDataTitle, StyledDataDescription} from './percentagePopupStyle'
import {useCustomDashboardViewProvider} from '../../../store/hooks/customDashboardView'

const ContentComponent = () => {
  const {prismProgram} = useCustomDashboardViewProvider()
  return (
    <ContentRow>
      <ContentCol>
        <StyledDataTitle variant='subtitle1'>
          {prismProgram} Data:
          <StyledDataDescription component='span' variant='body2'>
            Our data provides a more complete picture of community health by combining information from numerous sources
            with advanced modeling. This detailed approach means our data is more granular and may differ from other
            reports. The percentages shown are approximations, designed to account for margins of error in population
            estimates.
          </StyledDataDescription>
        </StyledDataTitle>
      </ContentCol>
    </ContentRow>
  )
}

export default ContentComponent
